import http from '@/http'

const state = {
  chapters: []
}

const getters = {
  getChapter: (state) => (id) => {
    console.log(id)
    return state.chapters.find(chapter => chapter.id === id) || {id: 0, title: '指定しない'}
  }
}

const mutations = {
  setChapters (state, data) {
    state.chapters = data.chapters
  },
  addChapter (state, data) {
    state.chapters.push(data.chapter)
  },
  deleteChapter (state, data) {
    var index = -1
    for (var i = 0, len = state.chapters.length; i < len; i++) {
      if (state.chapters[i].id === data.id) {
        index = i
        break
      }
    }
    if (index > -1) {
      state.chapters.splice(index, 1)
    }
  }
}

const actions = {
  fetch ({commit}, payload) {
    return http.post('/chapter/select/', {'book_id': payload.book_id}).then(function (response) {
      if (response.result && response.body) {
        commit('setChapters', {'chapters': response.body})
      }
    })
  },
  clear ({commit}) {
    commit('setChapters', {'chapters': []})
  },
  insert ({commit}, payload) {
    console.log(payload.chapter)
    return http.post('/chapter/insert/', payload.chapter).then(function (response) {
      return response
    })
  },
  update ({commit}, payload) {
    console.log(payload.chapter)
    return http.post('/chapter/update/', payload.chapter).then(function (response) {
      return response
    })
  },
  delete ({commit}, payload) {
    console.log(payload.id)
    return http.post('/chapter/delete/', {'id': payload.id}).then(function (response) {
      if (response.result) {
        commit('deleteChapter', {'id': payload.id})
      }
      return response
    }).catch(function (error) {
      return error
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Chapters.js